import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import BackToTop from '../../../commons/BackToTop';


export default class VenituriSiPreviziuni extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
       bilantData:[],
       prognoza:[],

        
        mapButtons:[{id:'financiarcontabil', label:'Inapoi Financiar', color:'#900DCB'},
        {id:'acf', label:'Analiza cash flow (ACF)', color:'#900DCB'}
    ]
}
    }

     componentDidMount(){
      
         this.getBilantData()
    }

    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }

    getBilantData = async()=>{
        let fs = new FromServer();

        let getData = await fs.getEvaluare()

        // console.log('chartData2 :', chartData2);

        // console.log('chartData2 :', chartData2);

   
        // console.warn('listCapitole :', getData);

       if(getData.r){
        
       

        let prognoza = getData.c.chartData

        

      

        this.setState({
                        prognoza:prognoza})
       }
    }
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
             
                <BackToTop
    
    />

                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Venituri si previziuni</h1>
            <div>
            {this.state.prognoza.map((b,idx)=>{

                if(b.chartPrognoza[0] === 0 && b.chartPrognoza[1] === 0 && b.chartPrognoza[2] === 0){
                    return (
                        <div key={idx} style={{width:'45%', display:'inline-block'}}>
                            <h2 className='pm-title'>{b.titlu}</h2>
                            <h4 style={{color:'red', 
                                        letterSpacing:1,
                                        fontWeight:600 }}>Informatiile necesare acestui grafic nu au fost gasite in bilant / balanta</h4>

                        </div>
                    )
                }
                return(
 
                    
                        <PreviziuniChartData
                            c={b}
                            key={idx}
                        />
            
                )
            })}

        
            </div>
           
         </div>
        );
       }
}